import AnalyticsTypes from '../constants/AnalyticsTypes';

function setAnalytics(type: AnalyticsTypes): void {
  sessionStorage.setItem(`analytics:${type}`, 'true');
}

export default setAnalytics;
